import { BasketballIcon, CasinoIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { cn } from '@repo/utils/cn';
import { UnStyledLink } from '@/components/common/link';
import { usePathname } from '@/i18n/routing';

const ProductCategories = () => {
  const pathname = usePathname();

  const isSportsBook = pathname.includes('/sportsbook');
  const isCasino = pathname.includes('/casino') || pathname.includes('/game');

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-[var(--surface-lighter-bg)] p-0.5">
      <UnStyledLink
        className="w-full"
        href="/casino"
      >
        <Button
          variant="blank"
          className={cn(
            'h-[48px] w-full rounded-lg rounded-b-none p-0 !vt-main-menu-item-text !vt-main-menu-item-bg hover:!vt-main-menu-item-text-hover hover:!vt-main-menu-item-bg-hover',
            isCasino && '!vt-main-menu-item-text-active !vt-main-menu-item-bg-active'
          )}
        >
          <CasinoIcon className="size-5" />
        </Button>
      </UnStyledLink>
      <UnStyledLink
        className="w-full"
        href="/sportsbook"
      >
        <Button
          variant="blank"
          className={cn(
            'h-[48px] w-full rounded-lg rounded-t-none p-0 !vt-main-menu-item-text !vt-main-menu-item-bg hover:!vt-main-menu-item-text-hover hover:!vt-main-menu-item-bg-hover',
            isSportsBook && '!vt-main-menu-item-text-active !vt-main-menu-item-bg-active'
          )}
        >
          <BasketballIcon className="size-5" />
        </Button>
      </UnStyledLink>
    </div>
  );
};

export default ProductCategories;
